<template>
  <v-row>
    <v-col cols="5"
      ><h1 class="subtitle-1 pt-2">Available Users</h1>
      <v-row>
        <v-col>
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="searchUsers"
            :outlined="outlinedInputs"
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card outlined>
        <v-data-table
          :headers="usersHeaders"
          :items="allUsers"
          show-select
          v-model="selectedUsers"
          :search="searchUsers"
        ></v-data-table>
      </v-card>
    </v-col>

    <v-col cols="2" align-self="center">
      <v-row justify="center" class="py-1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              fab
              color="success"
              @click="addToGroup"
              v-on="on"
              :disabled="addButtonDisabled"
            >
              <v-icon dark>mdi-arrow-right</v-icon>
            </v-btn>
          </template>
          <span>Add To Group</span>
        </v-tooltip>
      </v-row>
      <v-row justify="center" class="py-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              fab
              color="error"
              @click="removeFromGroup"
              :disabled="removeButtonDisabled"
            >
              <v-icon dark>mdi-arrow-left</v-icon>
            </v-btn>
          </template>
          <span>Remove From Group</span>
        </v-tooltip>
      </v-row>
    </v-col>
    <v-col cols="5">
      <h1 class="subtitle-1 pt-2">Users in this group</h1>
      <v-row>
        <v-col>
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="searchGroupUsers"
            :outlined="outlinedInputs"
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card outlined>
        <v-data-table
          :headers="headers"
          show-select
          :items="groupUsers"
          v-model="selectedGroupUsers"
          :search="searchGroupUsers"
        ></v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import { ALL_ACCESS_GROUPS } from "../../../../constants/graphql";
const ALL_USERS = gql`
  query allUsers {
    users(filter: { not_in_use_eq: false, is_active_eq:true, is_staff: true } ) {
      totalCount
      edges {
        node {
          id
          name
          username
          agentName
        }
      }
    }
  }
`;
const ADD_USERS_TO_GROUP = gql`
  mutation addUsersToAccessGroup($input: UpdateAccessGroupUsersInput!) {
    addUsersToAccessGroup(input: $input) {
      id
    }
  }
`;
const REMOVE_USERS_FROM_GROUP = gql`
  mutation removeUsersFromAccessGroup($input: UpdateAccessGroupUsersInput!) {
    removeUsersFromAccessGroup(input: $input) {
      id
    }
  }
`;

export default {
  name: "users-management",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    accessGroupId: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      groupUsers: [...this.value],
      searchGroupUsers: "",
      selectedGroupUsers: [],
      selectedUsers: [],
      searchUsers: "",
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
      ],
      usersHeaders: [
        {
          text: "Username",
          value: "username",
          name: "username",
        },
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Agent",
          value: "agentName",
          name: "agentName",
        },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    allUsers() {
      return this.users ? this.users.edges.map(removeGQLTypename) : [];
    },
    removeButtonDisabled() {
      return this.selectedGroupUsers.length == 0;
    },
    addButtonDisabled() {
      return this.selectedUsers.length == 0;
    },
  },

  watch: {
    value(newVal) {
      this.groupUsers = [...newVal];
    },
  },

  methods: {
    removeFromGroup() {
      const selectedIds = this.selectedGroupUsers.map((item) => item.id);
      this.groupUsers = this.groupUsers.filter(
        (item) => selectedIds.indexOf(item.id) == -1
      );

      this.removeUsersFromGroup(selectedIds);
    },
    addToGroup() {
      this.groupUsers = [
        ...new Set([...this.groupUsers, ...this.selectedUsers]),
      ];
      this.addUsesrToGroup();
    },
    emitChange() {
      this.$emit("input", [...this.groupUsers]);
    },
    removeUsersFromGroup(ids) {
      this.$apollo
        .mutate({
          mutation: REMOVE_USERS_FROM_GROUP,
          variables: {
            input: {
              accessGroupId: this.accessGroupId,
              users: ids,
            },
          },
          refetchQueries: [
            {
              query: ALL_ACCESS_GROUPS,
            },
          ],
        })
        .then(() => {
          this.selectedGroupUsers = [];
          this.$store.dispatch("showAppSnackbar", {
            msg: "Users removed.",
          });
          this.emitChange();
        })
        .catch(this.errorHandler);
    },
    addUsesrToGroup() {
      this.$apollo
        .mutate({
          mutation: ADD_USERS_TO_GROUP,
          variables: {
            input: {
              accessGroupId: this.accessGroupId,
              users: this.selectedUsers.map((u) => u.id),
            },
          },
          refetchQueries: [
            {
              query: ALL_ACCESS_GROUPS,
            },
          ],
        })
        .then(() => {
          this.selectedUsers = [];
          this.$store.dispatch("showAppSnackbar", {
            msg: "Users added.",
          });
          this.emitChange();
        })
        .catch(this.errorHandler);
    },
    errorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },
  },

  apollo: {
    users: {
      query: ALL_USERS,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/user-access-controls/UsersManagement.vue